var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letterhead"},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo__wrapper",attrs:{"to":{ name: 'landing', params: {} }}},[_c('h3',{staticClass:"logo__brand"},[_vm._v(_vm._s(_vm.title))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }